/**
 * Get the canonical URL for the current page
 * @returns {canonicalUrl} string
 */
export default function getCanonicalUrlOrNoIndex(subdomain, domain, tld, url) {
  let path = '';
  let noIndex = false;
  let canonicalUrl = '';

  if (subdomain !== 'www' || tld !== 'com') {
    noIndex = true;
  } else {
    if (typeof window !== 'undefined') {
      path = window.location.pathname;
    } else {
      path = url.indexOf('?') > -1 ? url.substr(0, url.indexOf('?')) : url;
    }

    if (path.substr(-1) !== '/') {
      path += '/';
    }

    canonicalUrl = `https://${subdomain}.${domain}.${tld}${path}`;
  }

  return { noIndex, canonicalUrl };
}
